







import {Component, Vue} from "vue-property-decorator";
import SessionWrapper from '@service/components/background-view/SesionWrapper.vue';
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import MeetingLive from "@share/meeting-view/MeetingLive.vue";

@Component({
    name: "WebConferencesRecordingView",
    components: { SessionWrapper, MeetingLive }
})
export default class WebConferencesRecordingView extends Vue {
    get isSession() {
        return this.$route.name == RouteNamesEnum.webConferencesRecording;
    }

    get isMeetings() {
        return this.$route.name == RouteNamesEnum.viewMeetingPublicRecording;
    }


    get id() {
        return this.$route.params.id;
    }

    mounted() {
        this.$store.dispatch('events/setInitSelected', this.$route.params.eventId);
    }
}
